
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import IconUpload from '@components/icons/icon-upload.svg';

export interface ImportModel {
  email: string,
  csv: string
}

@Component({
  name: 'ImportTab',
  components: {
    IconUpload,
  }
})
export default class ImportTab extends Vue {
  @Prop({ default: false})
  private success: boolean;

  @Prop({ default: false })
  private error: boolean;

  @Prop({ required: true })
  private value: ImportModel;

  private fileName: string = null;

  private dropActive = false;

  private fileTypeError = false;

  private dragLeaveTimeout = null;

  private fileChanged(e) {
    if (e.target.files && e.target.files[0]) {
      this.changeCsv(e.target.files[0])
    }
  }

  private changeCsv (file) {
    this.fileTypeError = false
    if (!file.name.endsWith('.csv')) {
      this.fileTypeError = true
      this.fileName = null
      this.$emit('input', { csv: '', email: this.value.email });
    } else {
      this.fileName = file.name
      const reader = new FileReader()
      reader.onload = (e) => {
        this.$emit('input', { csv: e.target.result, email: this.value.email });
      }
      reader.readAsText(file)
    }
  }

  private enableDropOverlay (e) {
    const dt = e.dataTransfer
    if (dt.types && (dt.types.indexOf ? dt.types.indexOf('Files') !== -1 : dt.types.contains('Files'))) {
      clearTimeout(this.dragLeaveTimeout)
      if (!this.dropActive) {
        this.dropActive = true
      }
    }
  }

  private imageDrop (e) {
    this.dropActive = false
    if (e.dataTransfer.items && e.dataTransfer.items[0].kind === 'file') {
      this.changeCsv(e.dataTransfer.items[0].getAsFile())
    }
  }

  private handleEmailInput(event) {
    const email = event.target.value;
    this.$emit('input', { email, csv: this.value.csv });
  }
}
